import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.4 });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-1 z-[70] origin-left bg-gradient-to-r from-[#244A32] via-[#C89D66] to-[#244A32]"
      style={{ scaleX }}
      data-testid="scroll-progress-bar"
    />
  );
}
